export { default as doDamage } from "./doDamage";
